import { ApiServiceBase } from "./apiServiceBase";

export class DocumentAccessRightsService extends ApiServiceBase {
  private apiUrl = "/api/accessrights/1.0/";

  getNotLoggedInData(
    onSuccess: (response: any) => void,
    onFailure: (response: any) => void
  ) {
    this.get(`${this.apiUrl}getnotloggedin`, onSuccess, onFailure);
  }

  getMissingPackageOrExtensionData(
    pageId: string,
    isBaseUser: boolean,
    onSuccess: (response: any) => void,
    onFailure: (response: any) => void
  ) {
    this.get(
      `${this.apiUrl}missingpackageorextension?pageId=${pageId}&isBaseUser=${isBaseUser}`,
      onSuccess,
      onFailure
    );
  }

  getExpiredTestPeriodData(
    onSuccess: (response: any) => void,
    onFailure: (response: any) => void
  ) {
    this.get(`${this.apiUrl}expiredtestperiod`, onSuccess, onFailure);
  }
}
